import React from "react";
import enquiryDetailModel from "venuescanner-js/react/components/Inbox/models/enquiry-detail";
import { inboxMobileView } from "venuescanner-js/constants/thread";
import {
  EnquiryInfoItem,
  EnquiryInfoItems,
} from "venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfoItem";
import PrimaryButton from "venuescanner-js/react/components/Buttons/PrimaryButton";

export function AcceptedViewedByHost() {
  return "Quote sent to organiser";
}

export function AcceptedViewedByOrganiser({
  thread,
  isMobileDevice,
  setActiveMobileView,
}) {
  if (isMobileDevice) {
    return (
      <div className="automated-message__detail">
        {`The host has shared a quote with you. The details are as follows: `}{" "}
        <EnquiryDetail
          thread={thread}
          setActiveMobileView={setActiveMobileView}
        />
      </div>
    );
  }

  return "The host has provided a quote to host your event. You can see the details on the panel to the right of this message";
}

export function ViewQuoteButton({ onClick }) {
  return (
    <div className="enquiry-info-view-quote-button">
      <PrimaryButton type="button" onClick={onClick}>
        View Quote
      </PrimaryButton>
    </div>
  );
}

const EnquiryDetail = ({ thread, setActiveMobileView }) => (
  <EnquiryInfoItems>
    {enquiryDetailModel(thread).map((field, index) =>
      field.value ? (
        <EnquiryInfoItem
          key={field.title + index}
          title={field.title}
          value={field.value}
          isCurrency={field.isCurrency ? field.isCurrency : false}
        />
      ) : null
    )}
    <ViewQuoteButton
      onClick={() => {
        setActiveMobileView(inboxMobileView.ENQUIRY);
      }}
    />
  </EnquiryInfoItems>
);
